import type {
  BlockSnapshot,
  DocSnapshot,
  FromBlockSnapshotPayload,
  FromBlockSnapshotResult,
  FromDocSnapshotPayload,
  FromDocSnapshotResult,
  FromSliceSnapshotPayload,
  FromSliceSnapshotResult,
  SliceSnapshot,
  ToBlockSnapshotPayload,
  ToDocSnapshotPayload,
  ToSliceSnapshotPayload,
} from '@blocksuite/store';
import { BaseAdapter } from '@blocksuite/store';

export type UriList = string;

// https://www.iana.org/assignments/media-types/text/uri-list
export class UriListAdapter extends BaseAdapter<UriList> {
  override fromDocSnapshot(
    _payload: FromDocSnapshotPayload
  ): Promise<FromDocSnapshotResult<UriList>> {
    throw new Error('Method not implemented.');
  }
  override fromBlockSnapshot(
    _payload: FromBlockSnapshotPayload
  ): Promise<FromBlockSnapshotResult<UriList>> {
    throw new Error('Method not implemented.');
  }
  override fromSliceSnapshot(
    _payload: FromSliceSnapshotPayload
  ): Promise<FromSliceSnapshotResult<UriList>> {
    throw new Error('Method not implemented.');
  }
  override toDocSnapshot(
    _payload: ToDocSnapshotPayload<UriList>
  ): Promise<DocSnapshot> {
    throw new Error('Method not implemented.');
  }
  override toSliceSnapshot(
    _payload: ToSliceSnapshotPayload<UriList>
  ): SliceSnapshot | Promise<SliceSnapshot | null> | null {
    throw new Error('Method not implemented.');
  }
  override toBlockSnapshot(
    _payload: ToBlockSnapshotPayload<UriList>
  ): BlockSnapshot {
    throw new Error('Method not implemented.');
  }

  parse(input: UriList) {
    return input
      .split('\n')
      .map(line => line.trim())
      .filter(line => line.length >= 3)
      .filter(line => line.at(0) !== '#')
      .filter(line => URL.canParse(line));
  }
}
